import { useEffect } from "react";
import "./Bridge.css";

function Bridge() {
  // 모바일 앱 딥링크 처리
  const openApp = () => {
    // URL 파라미터 추출 (userKey 등)
    const urlParams = new URLSearchParams(window.location.search);
    const queryString = urlParams.toString();

    // 딥링크 스킴 생성 (파라미터가 있으면 포함)
    const baseScheme = "goldttakshare://bridge";
    const deepLink = queryString
      ? `${baseScheme}?${queryString}`
      : baseScheme;

    // User Agent 확인
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);

    if (isIOS) {
      // iOS 앱 열기 시도
      window.location.href = deepLink;
      
      // 페이지가 백그라운드로 가면 앱이 열린 것으로 간주
      let appOpened = false;
      
      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
        }
      };
      
      const handleBlur = () => {
        appOpened = true;
      };
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('blur', handleBlur);
      
      // 앱이 설치되어 있지 않으면 App Store로 리다이렉트
      setTimeout(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('blur', handleBlur);
        
        // // 앱이 열리지 않았으면 스토어로 이동
        if (!appOpened && document.hasFocus()) {
          window.location.href =
            "https://apps.apple.com/us/app/%EA%B8%88%EB%9A%9D%EB%94%B1/id6748942265";
        }
      }, 3000);
    } else if (isAndroid) {
      // Android 앱 열기 시도
      window.location.href = deepLink;
      
      // 페이지가 백그라운드로 가면 앱이 열린 것으로 간주
      let appOpened = false;
      
      const handleVisibilityChange = () => {
        if (document.hidden) {
          appOpened = true;
        }
      };
      
      const handleBlur = () => {
        appOpened = true;
      };
      
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('blur', handleBlur);
      
      // 앱이 설치되어 있지 않으면 Play Store로 리다이렉트
      setTimeout(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('blur', handleBlur);
        
        // // 앱이 열리지 않았으면 스토어로 이동
        if (!appOpened && document.hasFocus()) {
          window.location.href =
            "https://play.google.com/store/apps/details?id=com.goldttak.goldttak_app";
        }
      }, 3000);
    } else {
      // 데스크톱에서는 안내 메시지
      alert("모바일 기기에서 접속해주세요.");
    }
  };

  useEffect(() => {
    // 사이트 진입 시 1초 후 자동으로 앱 열기
    const timer = setTimeout(() => {
      openApp();
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="bridge-container">
      <div className="bridge-content">
        <h1 className="bridge-title">앱을 여는 중...</h1>
        <p className="bridge-message">잠시만 기다려주세요.</p>
        <button className="bridge-button" onClick={openApp}>
          앱 바로가기
        </button>
      </div>
    </div>
  );
}

export default Bridge;
